<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="#">Central do Assinante</a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a :href="tenant.homepage" target="_blank" style="color: #000;">
          {{ tenant.name }}
        </a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
